"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var typography_1 = require("../../typography");
var Img_1 = __importDefault(require("../../misc/Images/Img/Img"));
var styles_1 = require("./styles");
var LibraryPostBlockOld = function (_a) {
    var title = _a.title, href = _a.href, description = _a.description, image = _a.image, type = _a.type, children = _a.children, commonProps = __rest(_a, ["title", "href", "description", "image", "type", "children"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "LibraryPostBlockOld" }, commonProps, { href: href, color: "GREY_90", hoverColor: "BLUE_50", ariaLabel: "View " + title }),
        react_1.default.createElement(styles_1.ImageWrapper, null,
            react_1.default.createElement(Img_1.default, __assign({}, image, { aspectRatio: "16:9", fit: "cover", isRounded: true, alt: image.alt || '' })),
            children),
        react_1.default.createElement(styles_1.Content, null,
            react_1.default.createElement(TextVerticalSpacer_1.default, { level: "3" },
                react_1.default.createElement(typography_1.Label, { color: "GREY_70", level: "1" }, type),
                react_1.default.createElement(typography_1.Heading, { level: "3" }, title),
                react_1.default.createElement(typography_1.Body, { level: "4", color: "GREY_90" }, description)))));
};
exports.default = LibraryPostBlockOld;
